// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VeeValidate from 'vee-validate';
import App from './App'
import router from './router'
import VueIziToast from 'vue-izitoast';
import 'izitoast/dist/css/iziToast.css';
import BulmaInput from './components/util/BulmaInput.vue'
import BulmaPagination from './components/util/BulmaPagination.vue'
import LoadingButton from './components/util/LoadingButton.vue'
import Collapse from './components/util/Collapse.vue'
import Item from './components/util/Item.vue'
import {EventBus} from './services/EventBus.js'
import {VueAuthenticate} from 'vue-authenticate'
import Vue2Dnd from 'vue2-dnd'
import $auth from 'vue-authenticate'
import VueScrollTo from 'vue-scrollto'
import VueAxios from 'vue-axios'
import axios from 'axios'
import VueClipboard from 'vue-clipboard2'
import VueSweetalert2 from 'vue-sweetalert2';
import VueProgressBar from 'vue-progressbar'
import VueAnalytics from 'vue-analytics'
import InputMask from 'vue-masked-input'
//import VueHtml5Editor from 'vue-html5-editor'
import Datepicker from 'vue-bulma-datepicker'
/*import Multiselect from 'vue-multiselect'
Vue.component(Multiselect)*/

import Multiselect from 'vue-multiselect'
import StarRating from 'vue-star-rating'
Vue.component('multiselect', Multiselect)
Vue.component('star-rating', StarRating)
Vue.component('masked-input', InputMask)

Vue.component('bulma-pagination', BulmaPagination);
Vue.component('bulma-input', BulmaInput);
Vue.component('loading-button', LoadingButton);
Vue.component('collapse', Collapse);
Vue.component('collapse-item', Item);

import Http from './mixins/http-mixin.vue';
Vue.mixin(Http);


//axios.defaults.baseURL = 'http://localhost:8000/';
//axios.defaults.baseURL = 'http://blablaapi.dinkara.com/';
//axios.defaults.baseURL = 'http://blablacommentz.test/';
axios.defaults.baseURL = 'https://api.blablacommentz.com/';
axios.defaults.storageURL = axios.defaults.baseURL + 'storage/';

Vue.use(VueAnalytics, {
    id: 'UA-111495631-1',
    checkDuplicatedScript: true
})

Vue.prototype.$me = {
    price: 0,
    user: {
        profile: {
            name: ''
        }
    },
    id: -1
};

Vue.use(axios);
Vue.use(VueAxios, axios);
Vue.use(Datepicker);
Vue.use(VeeValidate);
Vue.use(Vue2Dnd);
Vue.use(VueIziToast,
    {
        timeout: 5000,
        theme: 'dark',
        position: 'topCenter',
        progressBarColor: '#d5e1df'
    });
Vue.use(VueClipboard);
Vue.use(VueSweetalert2);
/*Vue.use(VueHtml5Editor,{
    name: "vue-editor",
    visibleModules: [
        "text",
        "color",
        "font",
        "align",
        "list",
        "link",
        "unlink",
        "hr",
        "eraser",
        "undo",
        "info",
    ]
});*/

Vue.use(VueProgressBar, {
    color: '#00d1b2',
    failedColor: '#ff3860',
    thickness: '2px',
    autoRevert: true,
    location: 'top',
    inverse: false
})

var auth_options = {
  baseUrl: axios.defaults.baseURL + "/api", // Your API domain
  tokenName: 'token',
  responseDataKey: 'data',
  logoutUrl: "api/logout",
  loginUrl: "/login",
  registerUrl: "/register",
  providers: {
    facebook: {
      clientId: '516738055355291',
      redirectUri: 'https://app.blablacommentz.com/', // Your client app URL

    },
    google: {
      clientId: '55138306884-3vefu9mekhlncgci48c0f5i075jr11jq.apps.googleusercontent.com',
      redirectUri: 'https://app.blablacommentz.com/', // Your client app URL
    }
  },

  /**
   * Default response interceptor for Axios library
   * @contect {VueAuthenticate}
   */
  bindResponseInterceptor: function ($auth) {
    $auth.$http.interceptors.response.use((response) => {
      $auth.setToken(response.data)
      return response
    })
  },

    /**
     * Default request interceptor for Axios library
     * @context {VueAuthenticate}
     */
    bindRequestInoterceptor: function ($auth) {
        const tokenHeader = $auth.options.tokenHeader;

        $auth.$http.interceptors.request.use((config) => {
          if ($auth.isAuthenticated()) {
            config.headers[tokenHeader] = [
              $auth.options.tokenType, $auth.getToken()
            ].join(' ')
          }
          return config
        })
    },

};

const auth = new VueAuthenticate(axios, auth_options);

window.axios = axios
window.auth = auth

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    app.$Progress.start();
    // Do something before request is sent
    return config;
}, function (error) {
    app.$Progress.fail();
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Do something with response data
    app.$Progress.finish();
    return response;
}, function (error) {
    // Do something with response error
    app.$Progress.fail();
    return Promise.reject(error);
});

Vue.config.productionTip = false

Vue.use($auth, auth_options);

// You can also pass in the default options
Vue.use(VueScrollTo, {
     container: "body",
     duration: 500,
     easing: "ease",
     offset: 0,
     cancelable: true,
     onDone: false,
     onCancel: false,
     x: false,
     y: true
 })

var app = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
});

window.app = app;

window.addEventListener('unhandledrejection', event => {
    // Can prevent error output on the console:
    event.preventDefault();

    var promise = event.promise;

    promise.catch((error) =>{
	EventBus.$emit("serverError", {component: app, error: error});
    });


});



// WEBPACK FOOTER //
// ./src/main.js